<template>
  <header class="page-game-header" :class="{ 'is-open-search': isOpenSearch }">
    <div class="page-game-header__inner">
      <div class="page-game-header__left">
        <!--step back bnt-->
        <UiBtn
          icon="chevrons/chevron-left"
          size-small-mobile
          color="gray"
          @click="smartStepBack"
        />
        <!--game name-->
        <UiText
          v-if="$device.isDesktop"
          :text="get_game.data.name"
          color="typography-title02"
          font="body-text-big"
          bold
          class="page-game-header__name"
        />
        <!--toggle favorites btn-->
        <ClientOnly>
          <UiBtn
            v-if="isLoggedIn && $device.isDesktop"
            :icon="isCurrentGameInFavorites ? 'common/heart' : 'common/heart-outline'"
            color="transparent"
            @click="onToggleFavorites"
          />
        </ClientOnly>
      </div>
      <div class="page-game-header__center">
        <div class="page-game-header__center-container">
          <SearchModal
            class="page-game-header__search"
            :class="{ 'is-open-search': isOpenSearch }"
            :is-open="isOpenSearch"
            @open="openSearch"
            @close="closeSearch"
          >
            <template #trigger>
              <UiBtn
                v-if="!isOpenSearch"
                icon="lobby/search"
                size-small-mobile
                color="gray"
                @click="openSearch"
              />
            </template>
          </SearchModal>
          <template v-if="!isOpenSearch">
            <template v-if="isLoggedIn || isServerToken">
              <HeaderData />
              <UiBtn
                size-small-mobile
                icon="cashbox/wallet-add"
                icon-left
                color="primary"
                :text="$t('buttons.deposit')"
                :to="$paths.cashbox"
              />
            </template>
            <template v-else>
              <BaseLogin size-small-mobile />
              <BaseRegisterAnimation
                :to="$paths.registration"
                v-bind="$device.isDesktop ? {'data-id': 'game-header-register-click'} : {}"
                size-small-mobile
              />
            </template>
            <!--            <UiBtn-->
            <!--              size-small-mobile-->
            <!--              color="gray"-->
            <!--              :signal="isDrawerSignal"-->
            <!--              @click="onToggleDrawer"-->
            <!--            />-->
          </template>
        </div>
      </div>
    </div>
    <!--    <GameDrawer v-model="isDrawerVisible" />-->
    <ClientOnly>
      <Transition name="fade">
        <BalanceDropdown
          v-if="isDropdownOpen.balance && isLoggedIn"
          class="page-game-header__balance-details"
        />
      </Transition>
    </ClientOnly>

    <ClientOnly>
      <BaseModalConfirm
        :value="isShowModalOnlyReal"
        :title="$t('gamePage.fillBalance')"
        :text="$t('gamePage.onlyReal')"
        image="Game/modals/balance.png"
        image-alt="info image"
        @submit="onOpenCashbox"
        @cancel="onModalsCancel"
      >
        <template #controls="{ onSubmit, onCancel }">
          <UiBtn
            color="primary"
            :text="$t('gamePage.fill')"
            @click="onSubmit"
          />
          <UiBtn
            color="gray"
            :text="$t('gamePage.exit')"
            @click="onCancel"
          />
        </template>
      </BaseModalConfirm>
    </ClientOnly>
    <!-- no balance modal -->
    <ClientOnly>
      <BaseModalConfirm
        :value="isShowModalNoBalance"
        :title="$t('gamePage.fillBalance')"
        :text="$t('gamePage.noMoney')"
        image="Game/modals/balance.png"
        image-alt="info image"
        @submit="onOpenCashbox"
        @cancel="onModalsCancel"
      >
        <template #controls="{ onSubmit, onCancel }">
          <UiBtn
            color="primary"
            :text="$t('gamePage.fill')"
            @click="onSubmit"
          />
          <UiBtn
            color="gray"
            :text="$t('gamePage.exit')"
            @click="onCancel"
          />
        </template>
      </BaseModalConfirm>
    </ClientOnly>
    <!-- no verification modal -->
    <ClientOnly>
      <BaseModalConfirm
        :value="isShowModalNoVerification"
        :title="$t('gamePage.nonVer')"
        :text="$t('gamePage.forGame')"
        :svg="{name: 'common/shield-cross', style: {color: 'var(--modals-icon-error)'}}"
        image-alt="info image"
        @cancel="onModalsCancel"
        @submit="$router.push({path: $paths.slots, query: { page: $paths.verifications }})"
      >
        <template #default>
          <BonusBanner no-close class="page-game-header__modal-bonus-banner" />
        </template>
        <template #controls="{ onSubmit }">
          <UiBtn
            color="primary"
            :text="$t('verification.title')"
            @click="onSubmit"
          />
        </template>
      </BaseModalConfirm>
    </ClientOnly>
    <ClientOnly>
      <LimitsModalBeforeGame
        v-if="isShowLimitsNotSetModal"
        @submit="fetchGame"
        @cancel="$router.push({path: $paths.slots.replace(/\/$/, '')})"
      />
    </ClientOnly>
  </header>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from 'vuex'
/** Components */
import BaseLogin from '~/components/Base/Login'
// import GameDrawer from '~/components/Game/GameDrawer'
import BaseModalConfirm from '~/components/Base/Modal/Confirm'
import BaseRegisterAnimation from '~/components/Base/RegisterAnimation'
import SearchModal from '~/components/Lobby/SearchModal'
import HeaderData from '~/components/App/AppHeader/HeaderData'
import BalanceDropdown from '~/components/App/AppHeader/BalanceDropdown'
import BonusBanner from '@/components/Verification/BonusBanner'

const GAMES_PLAY_ERROR_STATUS = {
  insufficientBalance: 'insufficient_balance',
  insufficientRealBalance: 'insufficient_real_balance',
  verificationRequired: 'verification_required',
  gameSessionLimitExceeded: 'game_session_limits_exceeded',
  requiredLimitsNotSet: 'required_limits_not_setted',
}

export default {
  name: 'GameHeader',
  components: {
    BalanceDropdown,
    HeaderData,
    BaseLogin,
    // GameDrawer,
    BaseModalConfirm,
    BaseRegisterAnimation,
    SearchModal,
    BonusBanner,
    LimitsModalBeforeGame: () => import('~/components/Limits/Modal/LimitsModalBeforeGame'),
  },
  data() {
    return {
      isDrawerSignal: true,
      isDrawerVisible: false,
      isGuestOnLoad: false, // for modal delay
      isModalDelayFinished: false, // for modal delay
    }
  },
  computed: {
    ...mapGetters('user', ['isLoggedIn']),
    ...mapGetters('base', ['isServerToken', 'isDropdownOpen']),
    ...mapGetters('game', ['get_game']),
    ...mapGetters('lobby', ['get_favoritesMetaList', 'isOpenSearch']),
    errorUser() {
      return this.get_game?.data?.errors?.user
    },
    isCurrentGameInFavorites() {
      return this.get_favoritesMetaList.data.some((term) => term === this.term)
    },
    term() {
      return this.$route.params.term
    },
    isBigModalShown() {
      return !!this.$route.query.bigModal
    },
    isAllowedToShowGameModals() {
      return !this.isBigModalShown
    },
    isShowModalNoBalance() {
      return this.isAllowedToShowGameModals && this.errorUser === GAMES_PLAY_ERROR_STATUS.insufficientBalance
    },
    isShowModalOnlyReal() {
      return this.isAllowedToShowGameModals && this.errorUser === GAMES_PLAY_ERROR_STATUS.insufficientRealBalance
    },
    isShowModalNoVerification() {
      return this.isAllowedToShowGameModals && this.errorUser === GAMES_PLAY_ERROR_STATUS.verificationRequired
    },
    isShowLimitsNotSetModal() {
      return this.isAllowedToShowGameModals && this.errorUser === GAMES_PLAY_ERROR_STATUS.requiredLimitsNotSet
    },
  },
  // for modal delay
  watch: {
    isLoggedIn() {
      if (!this.isLoggedIn) return
      setTimeout(() => {
        this.isModalDelayFinished = true
      }, 4000)
    },
  },
  // for modal delay
  mounted() {
    if (!this.isLoggedIn) this.isGuestOnLoad = true
  },
  destroyed() {
    this.set_game({ reset: true })
  },
  methods: {
    ...mapMutations('game',['set_game']),
    ...mapActions('game',['fetch_game']),
    ...mapActions('lobby', ['toggle_openSearch']),
    ...mapActions('base', ['closeDropdown']),
    async fetchGame() {
      await this.fetch_game({ isLoggedIn: this.isLoggedIn, term: this.$route.params.term })
    },
    onModalsCancel() {
      this.$router.push({ path: this.$paths.slots })
    },
    onOpenCashbox() {
      this.$router.push({ path: this.$paths.cashbox })
    },
    smartStepBack() {
      this.$smartStepBack.push({ defaultUrl: this.$paths.slots })
    },
    onToggleDrawer() {
      this.isDrawerSignal = false
      this.isDrawerVisible = !this.isDrawerVisible
    },
    onToggleFavorites() {
      this.$store.dispatch('lobby/toggle_gameFavorites', {
        game: this.term,
        toggle: !this.isCurrentGameInFavorites,
      })
    },
    openSearch() {
      this.toggle_openSearch(true)
      this.closeDropdown()
      this.isDrawerVisible = false
    },
    closeSearch() {
      this.toggle_openSearch(false)
    },
    toSettings() {
      this.$router.push({ path: this.$pathObj.profileSettings.path, query: { tab: 'limits' } })
    },
  },
}
</script>

<style lang="scss" src="./style.scss" scoped></style>
